import { PageSection } from '@/components/common/PageSection';
import { RuledList } from '@/components/common/RuledList';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Principles } from '@/pages/About/data';

const SectionId = 'principles';
const TitleId = 'principles-title';

export function PrinciplesSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId} tone="pad">
      <SectionHeading id={TitleId} title={Principles.title} description={Principles.description} />
      <RuledList items={Principles.items} columns="two" />
    </PageSection>
  );
}